/**
 * Licensed Materials - Property of IBM
 * IBM Watson Analytics (C) Copyright IBM Corp. 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../lib/@waca/core-client/js/core-client/ui/core/Class'
], function(Class) {

	var LoadingIndicator = Class.extend([], {

		init: function() {
			LoadingIndicator.inherited('init', this, arguments);
		},

		remove: function(){
			LoadingIndicator.inherited('remove', this);
		}
	});

	/**
	 * Show loading indicator on a DOM node.
	 *
	 * @param {Jquery} node - Jquery DOM node to show loading indicator on.
	 *
	 * @return {Jquery}  An instance of the loading indicator DOM node.
	 */
	LoadingIndicator.showLoadingIndicatorOnNode = function(node) {
		node.addClass('loading');

		return {
			remove: function () {
				node.removeClass('loading');
			}
		};
	};


	return LoadingIndicator;
});
